import { RedirectToSignIn } from '@clerk/clerk-react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { LandingPageV2 } from './landing-app/LandingV2';
import { LandingTemplate } from './landing-app/template';
import { SAMLCallbackPage } from './login-app/SAMLCallback';
import { SAMLLoginPage } from './login-app/SAMLLogin';
import { SectionTokenPage } from './login-app/SectionToken';
import { SignupPage } from './login-app/Signup';
import { LoginTemplate } from './login-app/template';

export function SignedOutRouter() {
  return (
    <Routes>
      <Route element={<LoginTemplate />}>
        <Route path="/login" element={<RedirectToSignIn />} />
      </Route>
      <Route element={<LoginTemplate />}>
        <Route path="/sign-up" element={<SignupPage />} />
      </Route>
      <Route element={<LoginTemplate />}>
        <Route path="/section/login" element={<SectionTokenPage />} />
      </Route>
      <Route element={<LoginTemplate />}>
        <Route path="/corp-login" element={<SAMLLoginPage />} />
        <Route path="/section" element={<SAMLLoginPage />} />
      </Route>
      <Route element={<LoginTemplate />}>
        <Route path="/corp-callback" element={<SAMLCallbackPage />} />
      </Route>
      <Route element={<LandingTemplate />}>
        <Route path="/" element={<LandingPageV2 />} />
      </Route>
      <Route path="*" element={<Navigate replace to="/" />} />
    </Routes>
  );
}
